var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJackpotFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.666 6.751c.19 0 .33.178.283.362-.15.6-.126 1.23.07 1.816l.262.788.315 1.26.026.122c.043.244.033.496-.028.736l-.035.12-.271.809a.751.751 0 001.424.474l.27-.81c.17-.512.21-1.06.117-1.59l-.048-.225-.324-1.294-.006-.028-.01-.027-.27-.81a1.754 1.754 0 01-.037-.977.958.958 0 01.93-.726h.82a1 1 0 01.878.52l1.616 2.958a10.946 10.946 0 011.34 4.915c.053 1.795-.033 3.498-1.07 4.75C17.113 22.08 14.697 22 11.75 22c-2.867 0-4.839-.021-6.64-2.105-1.103-1.275-1.162-2.947-1.088-4.752a11.233 11.233 0 011.357-4.915l1.616-2.957a1 1 0 01.877-.52h4.794zM17.174 2a1 1 0 01.863 1.506l-.734 1.25a1 1 0 01-.862.495H7.587a1 1 0 01-.863-.495l-.733-1.25A1 1 0 016.853 2h10.32z",
    fill: "currentColor"
  })));
}
SvgJackpotFilled.displayName = 'JackpotFilled';
export default SvgJackpotFilled;